import { useState, useEffect, Fragment } from 'react'
import axios from 'axios'
import { bttnGray, URL, sessionStorageGet, sessionStorageStore, updateTitleAndDescription, selectedTabGreen, unselectedTabGray, } from '../components/dictionary'
import avatar from "../../custom_assets/avatar.png"
import { TabContent } from '../components/UserProfile/TabContent'
import { getUserByToken, getUserProfile } from '../modules/auth/core/_requests'
import { getAuth, useAuth } from '../modules/auth'
import { UserProfileReactGAHandlers } from '../components/ReactGAHandlers'
import { logout } from '../modules/auth/core/_requests'
import { googleLogout } from '@react-oauth/google';

const handleUpdateUserData = async (user, formValues, setUserData, apiToken) => {

  const cleanedValues = Object.fromEntries(
    Object.entries(formValues).map(([key, value]) => [key, value === "" ? null : value])
  );

  const patchRequest = async () => {

    const res = await axios.patch(`${URL}/user_profiles/${user.user_id}`, cleanedValues, {
      headers: {
        Authorization: `Token ${apiToken}`,
        'Content-Type': 'application/json',
      },
    })
    setUserData(res.data)
    // console.log('Patch successful', res.data)
  }

  try {
    await patchRequest();

  } catch (error) {
    console.log(error);
    throw (error)
  }

}

const handleUpdateUserData2 = (user, formValues) => {

  const cleanedValues = Object.fromEntries(
    Object.entries(formValues).map(([key, value]) => [key, value === "" ? null : value])
  );

  const patchRequest = async () => {
    const res = await axios.patch(`${URL}/user_profiles/${user.user_id}`, cleanedValues)
    console.log('Patch successful', res.data)
  }

  try {
    patchRequest();

  } catch (error) {
    console.log(error);
    throw (error)
  }

}

const handleUpdateUserProfile = async (setUser, apiToken) => {

  const { data: user } = await getUserByToken(apiToken)
  // console.log('Django User:', user)

  const { data: userprofile } = await getUserProfile(user.pk, apiToken)
  setUser(userprofile)
  // console.log('Current User:', userprofile)
}

const handleUserProfilePatchIntroQuestions = async (introQuestions, user, setUser, apiToken) => {

  let userType = introQuestions?.a ?? undefined
  let hsGradYr = introQuestions?.b ?? undefined
  let familiarityWithProcess = introQuestions?.c ?? undefined

  let patchData: any = {};
  if (userType !== undefined) patchData.userType = userType;
  if (hsGradYr !== undefined) patchData.hsGradYr = hsGradYr;
  if (familiarityWithProcess !== undefined) patchData.familiarityWithProcess = familiarityWithProcess;

  const patch = await axios.patch(`${URL}/user_profiles/${user?.user_id}`, patchData, {
    headers: {
      Authorization: `Token ${apiToken}`,
      'Content-Type': 'application/json',
    },
  })

  // console.log('user updated,', patch.data)

  // Updates the user state in the app to align with the latest patch(es) made
  handleUpdateUserProfile(setUser, apiToken)
}

const handleUserProfilePatchOverviewVisits = async (user, setUser, apiToken) => {

  let overviewIntroductionKey = sessionStorageGet('overviewIntroduction')
  let overviewCollegeAppKey = sessionStorageGet('overviewCollegeApp')

  const checkOverviewVisits = (overviewIntroductionKey, overviewCollegeAppKey, user) => {

    // user?.familiarityWithProcess == integer field capturing user's response to how much they already know about the college admissions process
    // 3 == "Very familiar"

    if (user?.overviewIntroductionVisit == true && user?.overviewCollegeAppVisit == true) {
      return 3
    }
    else if (overviewIntroductionKey != null && overviewCollegeAppKey != null) {
      return 3
    }

    return undefined
  }

  let patchData = {
    overviewIntroductionVisit: ((user?.overviewIntroductionVisit)) || (overviewIntroductionKey != null) || false,
    overviewCollegeAppVisit: (user?.overviewCollegeAppVisit) || (overviewCollegeAppKey != null) || false,
    familiarityWithProcess: user?.familiarityWithProcess ? user?.familiarityWithProcess : checkOverviewVisits(overviewIntroductionKey, overviewCollegeAppKey, user)
  }

  try {
    const patch = await axios.patch(`${URL}/user_profiles/${user?.user_id}`, patchData, {
      headers: {
        Authorization: `Token ${apiToken}`,
        'Content-Type': 'application/json',
      },
    })
  } catch (error) {
    console.log('Error:', error)
  }

  // Updates the user state in the app to align with the latest patch(es) made
  handleUpdateUserProfile(setUser, apiToken)
}

const handleUpdateOverviewVisitsGivenUserFamiliarity = (user) => {
  let overviewIntroductionKey = sessionStorageGet('overviewIntroduction')
  let overviewCollegeAppKey = sessionStorageGet('overviewCollegeApp')

  if (overviewIntroductionKey == null && overviewCollegeAppKey == null && user?.familiarityWithProcess === 3) {
    sessionStorageStore('overviewIntroduction', 'true');
    sessionStorageStore('overviewCollegeApp', 'true');
  }
}

const UserProfile = ({ user, setUser, userCollegeInterest, setUserCollegeInterest, setCollegeDetailSelectedTab, selectedTab, setSelectedTab, tabOptions }) => {

  const { handleGAEventTabClick } = UserProfileReactGAHandlers()
  const { currentUser, setCurrentUser, saveAuth } = useAuth()
  const [userCollegelist, setUserCollegelist] = useState<any>([])
  const [loadingComplete, setLoadingComplete] = useState(false)
  const [userData, setUserData] = useState<any>({})
  const [socialAuthUser, setSocialAuthUser] = useState(true)

  let apiToken: any = undefined

  if (getAuth()?.api_token && getAuth()?.groups) {
    apiToken = getAuth()?.api_token
  }

  const handleSelectedTab = (val) => {
    setSelectedTab(val);
    handleGAEventTabClick(val)
  }

  useEffect(() => {

    updateTitleAndDescription()

    if (getAuth()?.api_token && getAuth()?.groups) {
      apiToken = getAuth()?.api_token
    }

    const getUserData = async (apiToken) => {
      const { data: user } = await getUserByToken(apiToken)
      // console.log('Django User:', user)
      if (user.contains_password) {
        setSocialAuthUser(false)
      }
    }
    getUserData(apiToken)

    const fetchData = async () => {

      try {
        if (loadingComplete === true) {
          setLoadingComplete(false)
        }

        const userDataAxios = axios.get(`${URL}/user_profiles/${currentUser?.user_id}`)
        const userCollegeInterestAxios = axios.get(`${URL}/user_college_interest`, {
          headers: {
            'Authorization': `Token ${apiToken}`
          }
        })
        const [userDataRes, userCollegeInterestRes] = await Promise.all([
          userDataAxios,
          userCollegeInterestAxios,
        ])

        // userDataRes
        // console.log('user data from call:', userDataRes.data)

        let userCollegeInterestSet = userCollegeInterestRes.data.filter((item) => item.user_profile_id == user?.user_id)

        await Promise.all([
          setUserData(userDataRes.data),
          setUserCollegelist(userCollegeInterestSet)
        ])

        setLoadingComplete(true)

      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()

  }, [])

  const handleMobileSelectedTab = (event) => {
    const selectedTab = event.target.value
    setSelectedTab(selectedTab);
    handleGAEventTabClick(selectedTab)

  }

  return <div style={{ margin: '0px 35px' }}>

    <div className='card shadow d-flex flex-column' style={{ width: '100%', marginTop: '30px' }}>

      <div className='d-flex flex-row'>
        <img src={avatar} alt='avatar' style={{ height: '150px', padding: '30px', borderRadius: '40px' }} />

        <div className='d-flex flex-column' style={{ marginTop: '30px' }}>
          <p style={{ fontSize: '20px' }}> {user?.firstName} {user?.lastName}</p>

          <button
            className="dca-font-M align-self-center"
            onClick={() => {
              handleUpdateOverviewVisitsGivenUserFamiliarity(user);

              logout();
              saveAuth(undefined)
              setCurrentUser(undefined)

              try {
                googleLogout()
              } catch (error) {
                console.log(error)
              }
            }}
            style={{
              color: 'black',
              background: bttnGray,
              borderRadius: '10px',
              border: 'transparent',
              padding: '6px',
              width: '100%'
            }}
          >Sign Out</button>
        </div>
      </div>

      {/* Use Bootstrap d-md-block to render while 768px or above */}
      <div className='d-none d-md-flex flex-row' style={{ width: '100%', marginLeft: '30px' }}>
        {tabOptions.map((tab, index) => (
          <div
            key={tab}
            className={`d-flex justify-content-center align-items-center dca-userProfile-tabs ${selectedTab === tabOptions[index] ? 'fw-bold' : ''}`}
            style={{
              backgroundColor: selectedTab === tabOptions[index] ? selectedTabGreen : unselectedTabGray,
              marginLeft: 0 === index ? '' : '10px'
            }}
            onClick={() => handleSelectedTab(tabOptions[index])}
          >

            <div className='text-nowrap' style={{ padding: '10px' }}>
              {tab}
            </div>
            <div
              style={{
                color: selectedTab === tabOptions[index] ? '#98F29B' : '',
                borderBottom: selectedTab === tabOptions[index] ? '3px solid' : '',
                width: '80%',

              }}></div>
          </div>))}
      </div>
    </div>

    {/* Mobile Replacement, only shows at below 768px */}
    <div className='d-flex d-md-none' style={{ width: '100%', marginTop: '30px' }}>
      <select
        className='form-select align-bottom'
        data-control="select2"
        value={selectedTab}
        onChange={(e) => {
          handleMobileSelectedTab(e)
        }}
        style={{ cursor: 'pointer', width: 'auto' }}
      >{tabOptions.map((tab, index) => <option value={tab} key={index}>{tab}</option>)}
      </select>
    </div>

    {loadingComplete && <Fragment>
      {/* Use Bootstrap d-md-block to render while 768px or above */}
      <div className='d-none d-md-flex' style={{ width: '100%' }}>
        <TabContent
          selectedTab={selectedTab}
          tabOptions={tabOptions}
          userData={userData}
          user={user}
          setUser={setUser}
          apiToken={apiToken}
          userCollegeInterest={userCollegeInterest}
          setUserCollegeInterest={setUserCollegeInterest}
          setUserData={setUserData}
          setCollegeDetailSelectedTab={setCollegeDetailSelectedTab}
          socialAuthUser={socialAuthUser} />
      </div>
      {/* Mobile Replacement, only shows at below 768px */}
      <div className='d-flex d-md-none' style={{ width: '100%' }}>
        <TabContent
          selectedTab={selectedTab}
          tabOptions={tabOptions}
          userData={userData}
          user={user}
          setUser={setUser}
          apiToken={apiToken}
          userCollegeInterest={userCollegeInterest}
          setUserCollegeInterest={setUserCollegeInterest}
          setUserData={setUserData}
          setCollegeDetailSelectedTab={setCollegeDetailSelectedTab}
          socialAuthUser={socialAuthUser}
          mobile={true} />
      </div></Fragment>}
  </div>
}

export { UserProfile, handleUpdateUserData, handleUpdateUserData2, handleUpdateUserProfile, handleUserProfilePatchIntroQuestions, handleUserProfilePatchOverviewVisits }